module.exports = __webpack_public_path__ + "img/5.12f1d0ff.jpg";